import type { FaireProductEntity } from "../../entity_types/product";

export const p_ytgpzdy27p: FaireProductEntity = {
  token: "p_ytgpzdy27p",
  type: "product",
  name: "Falling Confetti Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/5c9a79a394ce6e9b108d88579bc8b5e46d5bc7b73c2198f20d8d6e72757b4dcb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3a628a73fd7745aac6ad954b2389fab3eb357ca23c910e453848653f5dc5488.jpeg",
    "https://cdn.faire.com/fastly/4d925e72b2a57615cbd8ae039e0e25d4b0231227354423dff53fe86bed6904c0.png",
    "https://cdn.faire.com/fastly/d61936a0372cdfc07b5c0d2d7f9ae48191329f742177a6a97f2d150fde64bb63.png"
  ],
  priceDollars: 3,
  description: "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:56.399Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
